import { useState } from 'react';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { PiListLight } from 'react-icons/pi';
import { SupportButton } from 'src/modules/support/components/molecules/support-button';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import { MobileSidebar } from './mobile-sidebar';

export const MobileHeader = () => {
  const { t } = useI18n();
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] =
    useState<boolean>(false);

  const handleMobileMenuOpen = () => {
    setIsMobileSidebarOpen(true);
  };

  const handleMobileSidebarToggle = (isOpen: boolean) => {
    setIsMobileSidebarOpen(isOpen);
  };

  return (
    <>
      <header className="md:hidden shrink-0 bg-white border-b border-gray-200 px-3 py-2.5 grid grid-cols-[1fr_auto_1fr] items-center gap-2">
        <Button
          onClick={handleMobileMenuOpen}
          className="!h-11 !w-11 !p-2 justify-self-start hover:!bg-neutral-100"
          aria-label={t('sidebar.openNavigation')}
          appearance="ghost"
          variant="primary"
          size="sm"
          isIconOnly
        >
          <PiListLight className="h-6 w-6" />
        </Button>

        <img
          src="/logos/logo-full-light.svg"
          alt="Comos Logo"
          className="h-6 max-w-[112px] [@media(min-width:360px)]:h-7 [@media(min-width:360px)]:max-w-[128px]"
        />

        <div className="justify-self-end">
          <SupportButton variant="mobile" />
        </div>
      </header>

      <MobileSidebar
        isOpen={isMobileSidebarOpen}
        onClose={() => handleMobileSidebarToggle(false)}
      />
    </>
  );
};
